import { render } from "preact";
import { App } from "./components/App";
import { BookingPage } from "./components/BookingPage";
import { FormPage } from "./components/FormPage";
import { FormPreview } from "./components/FormPreview";
import { PayPage } from "./components/PayPage";
import "./styles.css";

const API_ORIGIN =
  (import.meta.env["VITE_API_ORIGIN"] as string | undefined) ?? "https://api.wapadesk.com";

/**
 * The booking page (owner request, 15 October 2026) for /book/<slug|id>, and for the older booking
 * links that asked the chat to start at the appointment step (?start=booking).
 */
function bookingRef(): string | undefined {
  const [, kind, id] = location.pathname.split("/");
  const q = new URLSearchParams(location.search);
  if (kind === "book" && id) return decodeURIComponent(id);
  if ((kind === "go" || kind === "c") && id && q.get("start") === "booking")
    return decodeURIComponent(id);
  return undefined;
}

/** Page forms (16 October 2026): /form/<slug|clinicId>/<formId>. */
function pageFormRef(): { clinic: string; form: string } | undefined {
  const [, kind, clinic, form] = location.pathname.split("/");
  return kind === "form" && clinic && form
    ? { clinic: decodeURIComponent(clinic), form: decodeURIComponent(form) }
    : undefined;
}

/** Deposit pay page (17 October 2026): /pay/<token>. */
function payToken(): string | undefined {
  const [, kind, token] = location.pathname.split("/");
  return kind === "pay" && token ? decodeURIComponent(token) : undefined;
}

const root = document.getElementById("app");
const pay = payToken();
const pageForm = pageFormRef();
const ref = bookingRef();
// Opened by the loader's "Book now" button: the page sits in the overlay and needs a close button.
const inOverlay = new URLSearchParams(location.search).get("overlay") === "1";
if (root)
  render(
    pay ? (
      <PayPage token={pay} apiOrigin={API_ORIGIN} />
    ) : location.pathname.replace(/\/+$/, "") === "/preview-form" ? (
      <FormPreview apiOrigin={API_ORIGIN} />
    ) : pageForm ? (
      <FormPage clinicRef={pageForm.clinic} formId={pageForm.form} apiOrigin={API_ORIGIN} />
    ) : ref ? (
      <BookingPage
        clinicRef={ref}
        apiOrigin={API_ORIGIN}
        overlayClose={inOverlay}
        onClose={
          inOverlay
            ? () =>
                window.parent.postMessage({ source: "wapadesk", type: "close", payload: {} }, "*")
            : undefined
        }
      />
    ) : (
      <App />
    ),
    root,
  );
